import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../types";
import api from "../../API"

interface UserInfoState {
  user: User | null;
  login: boolean;
}

interface UserInfo {
  data: UserInfoState;
}

const initialState: UserInfo = {
  data: { user: { email: null, name: null, id: null, roles: [], state: null, user_id: null }, login: false },
};

const logout_fn = async() => {
  await api.post("/logout");
}

export const userSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<any>) => {
      // console.log('userSlice' , action)
      state.data.user = action.payload;
      state.data.login = true;
      // state.auth.auth = true;
    },
    logoutUser: (state) => {
        // console.log('action ??? ' , action)
        logout_fn();
        state.data = { user: { email: null, name: null, id: null, roles:[], state: null, user_id: null }, login: false };
        window.location.href = '/';
      },
  },
});

export const { setUserInfo, logoutUser } = userSlice.actions;

export default userSlice.reducer;
